import { render, staticRenderFns } from "./ControlUsuarios.vue?vue&type=template&id=4dd5f766"
import script from "./ControlUsuarios.vue?vue&type=script&lang=js"
export * from "./ControlUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports